import { render } from "./linkEmployee.vue?vue&type=template&id=3f2a09ef&scoped=true"
import script from "./linkEmployee.vue?vue&type=script&lang=js"
export * from "./linkEmployee.vue?vue&type=script&lang=js"

import "./linkEmployee.vue?vue&type=style&index=0&id=3f2a09ef&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2a09ef"]])

export default __exports__